import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

/** Classe utilitaire pour le Chart */
@Component({
    components: {}
})
export default class ChartUtils extends Vue {

	//#region Tranformation des fonctions
	
	/**
	 * Transformation du string en fonction pour les diférentes propriétés.
	 * @param obj
	 * @constructor
	 */
	public TransformFunctions(obj: any, functionsList: any) {
		const transformFunction = (obj: any, val: string) => {
			//console.debug("ChartUtils.ts - TransformFunctions() - functionsList", functionsList);
            if (functionsList) {
				//console.debug("ChartUtils.ts - TransformFunctions() - functionsList OK");
				if (obj && obj[val]) {
					let value = obj[val];
					if (Object.keys(functionsList).find(val => val == value)) {
						obj[val] = functionsList[value];
					}
				}
            } else {
				//console.debug("ChartUtils.ts - TransformFunctions() - functionsList KO - obj", obj);
				if (obj && obj[val]) {
					//console.debug("ChartUtils.ts - TransformFunctions() - obj[val]", obj[val], typeof obj[val]);
					if (typeof obj[val] == "function") {
						//console.debug("ChartUtils.ts - TransformFunctions() - obj[val].name", obj[val].name);
						obj[val] = obj[val].name;
					}
				}
			}
		};

		//console.debug("ChartUtils.ts - TransformFunctions() - obj", obj);
		if (obj != undefined) {
			transformFunction(obj.axisPointer?.label, 'formatter');
			transformFunction(obj.legend, 'formatter');
			transformFunction(obj.legend, 'pageFormatter');
			transformFunction(obj.tooltip?.axisPointer, 'animationDuration');
			transformFunction(obj.tooltip?.axisPointer, 'animationDelay');
			transformFunction(obj.tooltip?.axisPointer, 'animationDurationUpdate');
			transformFunction(obj.tooltip?.axisPointer, 'animationDelayUpdate');
			transformFunction(obj.tooltip, 'formatter');
			transformFunction(obj.tooltip, 'valueFormatter');
			obj.dataZoom?.forEach(function (val) {
				transformFunction(val, 'labelFormatter');
			});
			obj.grid?.forEach(function (val) {
				transformFunction(val.tooltip, 'formatter');
				transformFunction(val.tooltip, 'valueFormatter');
			});
			obj.visualMap?.forEach(function (val) {
				transformFunction(val, 'formatter');
			});
			obj.xAxis?.forEach(function (val) {
				transformFunction(val, 'min');
				transformFunction(val, 'max');
				transformFunction(val, 'animationDuration');
				transformFunction(val, 'animationDelay');
				transformFunction(val, 'animationDurationUpdate');
				transformFunction(val, 'animationDelayUpdate');
				transformFunction(val.axisTick, 'interval');
				transformFunction(val.axisLabel, 'interval');
				transformFunction(val.axisLabel, 'formatter');
				transformFunction(val.axisLabel, 'color');
				transformFunction(val.splitLine, 'interval');
				transformFunction(val.splitArea, 'interval');
				transformFunction(val.axisPointer?.label, 'formatter');

				if ((('nameTextStyle') in val) && (val.nameTextStyle) &&
					(('rich') in val.nameTextStyle) && (val.nameTextStyle.rich != undefined) &&
					(typeof val.nameTextStyle.rich == 'string'))
					val.nameTextStyle.rich = JSON.parse(val.nameTextStyle.rich);
				if (val.name != undefined && val.name?.indexOf('\n}{') < 0){
					console.debug('val', val);
					val.name = val.name.replace('}{','\n}{');
				}
				//console.debug("ChartUtils.ts - TransformFunctions() - val", val.name);
			});
			obj.yAxis?.forEach(function (val) {
				//console.debug("ChartUtils.ts - TransformFunctions() - obj - y", obj, val);
				transformFunction(val, 'min');
				transformFunction(val, 'max');
				transformFunction(val, 'animationDuration');
				transformFunction(val, 'animationDelay');
				transformFunction(val, 'animationDurationUpdate');
				transformFunction(val, 'animationDelayUpdate');
				transformFunction(val.axisTick, 'interval');
				transformFunction(val.axisLabel, 'interval');
				transformFunction(val.axisLabel, 'formatter');
				transformFunction(val.axisLabel, 'color');
				transformFunction(val.splitLine, 'interval');
				transformFunction(val.splitArea, 'interval');
				transformFunction(val.axisPointer?.label, 'formatter');

				if ((('nameTextStyle') in val) && (val.nameTextStyle) &&
					(('rich') in val.nameTextStyle) && (val.nameTextStyle.rich != undefined) &&
					(typeof val.nameTextStyle.rich == 'string'))
					val.nameTextStyle.rich = JSON.parse(val.nameTextStyle.rich);
				if (val.name != undefined && val.name?.indexOf('\n}{') < 0){
					console.debug('val', val);
					val.name = val.name.replace('}{','\n}{');
				}
				//console.debug("ChartUtils.ts - TransformFunctions() - val", val.name);
			});
			obj.series?.forEach(function (val) {
				transformFunction(val, 'animationDuration');
				transformFunction(val, 'animationDelay');
				transformFunction(val, 'animationDurationUpdate');
				transformFunction(val, 'animationDelayUpdate');
				transformFunction(val, 'universalTransition.delay');
				transformFunction(val, 'renderItem');
				transformFunction(val, 'symbol');
				transformFunction(val, 'symbolSize');
				transformFunction(val, 'symbolRotate');
				transformFunction(val, 'sort');
				transformFunction(val, 'labelLayout');
				transformFunction(val.label, 'formatter');
				transformFunction(val.universalTransition, 'animationDelay');
				transformFunction(val.universalTransition, 'animationDelayUpdate');
				transformFunction(val.hoverAnimation, 'animationDuration');
				transformFunction(val.hoverAnimation, 'animationDurationUpdate');
				transformFunction(val.hoverAnimation, 'animationDelay');
				transformFunction(val.hoverAnimation, 'animationDelayUpdate');
				transformFunction(val.itemStyle, 'color');
				transformFunction(val.axisLabel, 'formatter');
				transformFunction(val.edgeLabel, 'formatter');
				transformFunction(val.endLabel, 'formatter');
				transformFunction(val.effect, 'delay');
				transformFunction(val.projection, 'project');
				transformFunction(val.projection, 'unproject');
				transformFunction(val.projection, 'stream');
				transformFunction(val.upperLabel, 'formatter');
				transformFunction(val.markLine?.label, 'formatter');
				transformFunction(val.detail, 'formatter');
				val.data?.forEach(function(data) {
					transformFunction(data.detail, 'formatter');
				});

                const bool = /true|false|True|False/g
                if ((('step') in val) && (val.step) && (typeof val.step != 'boolean') && val.step.toString().search(bool) >= 0) {
                    val.step = val.step === "true" || val.step === "True";
                    //console.debug("ChartUtils.ts - TransformFunctions() - val.step ", val.step, typeof val.step);
                }
                if ((('smooth') in val) && (val.smooth) && (typeof val.smooth != 'boolean') && val.smooth.toString().search(bool) >= 0) {
                    val.smooth = val.smooth === "true" || val.smooth === "True";
                    //console.debug("ChartUtils.ts - TransformFunctions() - val.smooth ", val.smooth, typeof val.smooth);
                }
			});
		}
	}


	public CopyFunctionWithName(oldObj: any, newObj: any) {
		const copyFunctionName = (oldObj: any, newObj: any, funct: string, ) => {
			//console.debug("ChartUtils.ts - CopyFunctionWithName() - functionsList KO - oldObj", oldObj);
			if (oldObj && oldObj[funct]) {
				//console.debug("ChartUtils.ts - CopyFunctionWithName() - oldObj[funct]", oldObj[funct], typeof oldObj[funct]);
				if (typeof oldObj[funct] == "function") {
					//console.debug("ChartUtils.ts - CopyFunctionWithName() - oldObj[val].name", oldObj[funct].name);
					newObj[funct] = oldObj[funct].name;
				}
			}
		};

		//console.debug("ChartUtils.ts - CopyFunctionWithName() - oldObj", oldObj);
		//console.debug("ChartUtils.ts - CopyFunctionWithName() - newObj", newObj);
		if (oldObj != undefined) {
			copyFunctionName(oldObj.axisPointer?.label, newObj.axisPointer?.label, 'formatter');
			copyFunctionName(oldObj.legend, newObj.legend,'formatter');
			copyFunctionName(oldObj.legend, newObj.legend,'pageFormatter');
			copyFunctionName(oldObj.tooltip?.axisPointer, newObj.tooltip?.axisPointer, 'animationDuration');
			copyFunctionName(oldObj.tooltip?.axisPointer, newObj.tooltip?.axisPointer,'animationDelay');
			copyFunctionName(oldObj.tooltip?.axisPointer, newObj.tooltip?.axisPointer,'animationDurationUpdate');
			copyFunctionName(oldObj.tooltip?.axisPointer, newObj.tooltip?.axisPointer,'animationDelayUpdate');
			copyFunctionName(oldObj.tooltip,newObj.tooltip, 'formatter');
			copyFunctionName(oldObj.tooltip, newObj.tooltip,'valueFormatter');
			oldObj.dataZoom?.forEach(function (val, index) {
				copyFunctionName(val, newObj.dataZoom[index], 'labelFormatter');
			});
			oldObj.grid?.forEach(function (val, index) {
				copyFunctionName(val.tooltip, newObj.grid[index].tooltip, 'formatter');
				copyFunctionName(val.tooltip, newObj.grid[index].tooltip,'valueFormatter');
			});
			oldObj.visualMap?.forEach(function (val, index) {
				copyFunctionName(val, newObj.visualMap[index], 'formatter');
			});
			oldObj.xAxis?.forEach(function (val, index) {
				copyFunctionName(val, newObj.xAxis[index], 'min');
				copyFunctionName(val, newObj.xAxis[index], 'max');
				copyFunctionName(val, newObj.xAxis[index], 'animationDuration');
				copyFunctionName(val, newObj.xAxis[index], 'animationDelay');
				copyFunctionName(val, newObj.xAxis[index], 'animationDurationUpdate');
				copyFunctionName(val, newObj.xAxis[index], 'animationDelayUpdate');
				copyFunctionName(val.axisTick, newObj.xAxis[index].axisTick, 'interval');
				copyFunctionName(val.axisLabel, newObj.xAxis[index].axisLabel, 'interval');
				copyFunctionName(val.axisLabel, newObj.xAxis[index].axisLabel, 'formatter');
				copyFunctionName(val.axisLabel, newObj.xAxis[index].axisLabel, 'color');
				copyFunctionName(val.splitLine, newObj.xAxis[index].splitLine, 'interval');
				copyFunctionName(val.splitArea, newObj.xAxis[index].splitArea, 'interval');
				copyFunctionName(val.axisPointer?.label, newObj.xAxis[index].axisPointer?.label, 'formatter');
				
				if ((('nameTextStyle') in val) && (val.nameTextStyle) &&
					(('rich') in val.nameTextStyle))
					newObj.yAxis[index].nameTextStyle.rich = JSON.stringify(val.nameTextStyle.rich);
				if (val.name != undefined && val.name?.indexOf('\n}{') < 0){
					newObj.yAxis[index].name = val.name.replace('\n}{','}{');
				}
				//console.debug("ChartUtils.ts - CopyFunctionWithName() - yAxis - Val", val);
			});
			oldObj.yAxis?.forEach(function (val, index) {
				copyFunctionName(val, newObj.yAxis[index],'min');
				copyFunctionName(val, newObj.yAxis[index],'max');
				copyFunctionName(val, newObj.yAxis[index],'animationDuration');
				copyFunctionName(val, newObj.yAxis[index],'animationDelay');
				copyFunctionName(val, newObj.yAxis[index],'animationDurationUpdate');
				copyFunctionName(val, newObj.yAxis[index],'animationDelayUpdate');
				copyFunctionName(val.axisTick, newObj.yAxis[index].axisTick,'interval');
				copyFunctionName(val.axisLabel, newObj.yAxis[index].axisLabel,'interval');
				copyFunctionName(val.axisLabel, newObj.yAxis[index].axisLabel,'formatter');
				copyFunctionName(val.axisLabel, newObj.yAxis[index].axisLabel,'color');
				copyFunctionName(val.splitLine, newObj.yAxis[index].splitLine,'interval');
				copyFunctionName(val.splitArea, newObj.yAxis[index].splitArea,'interval');
				copyFunctionName(val.axisPointer?.label, newObj.yAxis[index].axisPointer?.label,'formatter');

				if ((('nameTextStyle') in val) && (val.nameTextStyle) &&
					(('rich') in val.nameTextStyle))
					newObj.yAxis[index].nameTextStyle.rich = JSON.stringify(val.nameTextStyle.rich);
				if (val.name != undefined && val.name?.indexOf('\n}{') < 0){
					newObj.yAxis[index].name = val.name.replace('\n}{','}{');
				}
				//console.debug("ChartUtils.ts - CopyFunctionWithName() - yAxis - Val", val);
			});
			oldObj.series?.forEach(function (val, index) {
				copyFunctionName(val, newObj.series[index], 'animationDuration');
				copyFunctionName(val, newObj.series[index], 'animationDelay');
				copyFunctionName(val, newObj.series[index], 'animationDurationUpdate');
				copyFunctionName(val, newObj.series[index], 'animationDelayUpdate');
				copyFunctionName(val, newObj.series[index], 'universalTransition.delay');
				copyFunctionName(val, newObj.series[index], 'renderItem');
				copyFunctionName(val, newObj.series[index], 'symbol');
				copyFunctionName(val, newObj.series[index], 'symbolSize');
				copyFunctionName(val, newObj.series[index], 'symbolRotate');
				copyFunctionName(val, newObj.series[index], 'sort');
				copyFunctionName(val, newObj.series[index], 'labelLayout');
				copyFunctionName(val.label, newObj.series[index].label, 'formatter');
				copyFunctionName(val.universalTransition, newObj.series[index].universalTransition, 'animationDelay');
				copyFunctionName(val.universalTransition, newObj.series[index].universalTransition, 'animationDelayUpdate');
				copyFunctionName(val.hoverAnimation, newObj.series[index].hoverAnimation, 'animationDuration');
				copyFunctionName(val.hoverAnimation, newObj.series[index].hoverAnimation, 'animationDurationUpdate');
				copyFunctionName(val.hoverAnimation, newObj.series[index].hoverAnimation, 'animationDelay');
				copyFunctionName(val.hoverAnimation, newObj.series[index].hoverAnimation, 'animationDelayUpdate');
				copyFunctionName(val.itemStyle, newObj.series[index].itemStyle, 'color');
				copyFunctionName(val.axisLabel, newObj.series[index].axisLabel, 'formatter');
				copyFunctionName(val.edgeLabel, newObj.series[index].edgeLabel, 'formatter');
				copyFunctionName(val.endLabel, newObj.series[index].endLabel, 'formatter');
				copyFunctionName(val.effect, newObj.series[index].effect, 'delay');
				copyFunctionName(val.projection, newObj.series[index].projection, 'project');
				copyFunctionName(val.projection, newObj.series[index].projection, 'unproject');
				copyFunctionName(val.projection, newObj.series[index].projection, 'stream');
				copyFunctionName(val.upperLabel, newObj.series[index].upperLabel, 'formatter');
				copyFunctionName(val.markLine?.label, newObj.series[index].markLine?.label, 'formatter');
				copyFunctionName(val.detail, newObj.series[index].detail, 'formatter');
				val.data?.forEach(function(data, dataIndex) {
					copyFunctionName(data.detail, newObj.series[index].data[dataIndex].formatter, 'formatter');
				});
			});
		}
	}

	//#endregion

}